<template>
  <v-layout column>
    <v-navigation-drawer v-model="right" fixed right temporary light>
      <v-flex class="pl-2 pt-1" style="height: 100vh" v-if="loading">
        <v-layout align-center justify-center row fill-height>
          <v-progress-circular
            indeterminate
            color="#c0c0c0"
          ></v-progress-circular>
        </v-layout>
      </v-flex>
      <v-flex class="pl-2 pt-1" v-if="!loading && error !== ''">
        <div class="error">{{ error }}</div>
      </v-flex>
      <v-flex class="pl-2 pt-1" v-if="!loading && uc">
        <v-list-tile>
          <v-flex sm6 md6 xs6>
            <v-icon @click.stop="right = !right">close</v-icon>
          </v-flex>
          <v-flex sm6 md6 xs6>
            <div :class="`detail-status detail-status--${uc.status}`">
              {{ this.status }}
            </div>
          </v-flex>
        </v-list-tile>
        <v-flex sm12 md12 xs12>
          <div class="title pt-2" v-if="uc.user">
            {{ uc.user ? uc.user.name : "" }}
          </div>
          <div class="sub-title pb-3">
            <small>ID: {{ uc.user ? uc.user.id : "" }}</small>
          </div>
        </v-flex>
        <v-flex sm12 md12 xs12 class="pr-2">
          <p class="sub-title">
            {{ uc.address.address + " " + uc.address.address_number || "" }}
          </p>
          <p class="sub-title">{{ uc.address.district || "" }}</p>
          <p class="sub-title">
            {{
              uc.address.postal_code +
                " " +
                uc.address.city +
                ", " +
                uc.address.state.initials || ""
            }}
          </p>
          <p class="sub-title">
            CPF: {{ uc.user ? uc.user.cpf : "" | formatCPF }}
          </p>
          <p class="sub-title">Tel: {{ uc.user ? uc.user.phone : "" }}</p>
        </v-flex>
        <!-- </v-list-tile> -->
        <!-- <v-list-tile>
          <v-flex sm12 md12 xs12>
            <div class="sub-title">{{uc.address.district || ''}}</div>
          </v-flex>
        </v-list-tile>
        <v-list-tile>
          <v-flex sm12 md12 xs12>
            <div class="sub-title">{{uc.address.postal_code + ' ' + uc.address.city + ', ' + uc.address.state.initials || ''}}</div>
          </v-flex>
        </v-list-tile>
        <v-list-tile>
          <v-flex sm12 md12 xs12>
            <div class="sub-title">{{uc.user?uc.user.cpf:''}}</div>
          </v-flex>
        </v-list-tile> -->
        <!-- <v-list-tile>
          <v-flex sm12 md12 xs12>
            <div class="sub-title">{{uc.address.address + ' ' + uc.address.address_number || ''}}</div>
            <div class="sub-title">{{uc.address.district || ''}}</div>
            <div class="sub-title">{{uc.address.postal_code + ' ' + uc.address.city + ', ' + uc.address.state.initials || ''}}</div>
            <div class="sub-title">{{uc.user?uc.user.cpf:''}}</div>
          </v-flex>
        </v-list-tile> -->
        <v-divider />
        <!-- Número de Instalação -->
        <v-list-tile avatar class="v-list-item">
          <v-list-tile-action>
            <v-icon class="grey--text">home</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-sub-title>Núm Instalação</v-list-tile-sub-title>
            <v-list-tile-title v-text="uc.installation_number" />
          </v-list-tile-content>
        </v-list-tile>

        <!-- Número de Cliente -->
        <v-list-tile avatar class="v-list-item">
          <v-list-tile-action>
            <v-icon class="grey--text">person</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-sub-title>Núm Cliente</v-list-tile-sub-title>
            <v-list-tile-title v-text="uc.customer_number" />
          </v-list-tile-content>
        </v-list-tile>

        <!-- Ultima fatura -->
        <v-list-tile avatar class="v-list-item">
          <v-list-tile-action>
            <v-icon outline class="grey--text">account_balance_wallet</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-sub-title>Últ. Fatura</v-list-tile-sub-title>
            <v-list-tile-title v-text="uc.user.last_invoice" />
          </v-list-tile-content>
        </v-list-tile>
        <!-- Açoes -->
        <!-- <div pt-5 class="text-xs-center">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn fab dark color="red" 
              v-on="on"
                v-if="user.status !== 'paid'"
                @click.stop="dialog = true"
              >
                <v-icon large dark>cached</v-icon>
              </v-btn>
            </template>
            <span>Reprocessar o faturamento.</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn 
                fab dark color="indigo" 
                v-on="on"
                v-if="user.transaction && user.transaction.payment_method === 'boleto' && user.status !== 'paid'"
                :href="user.transaction.boleto_url"
                target="_blank"
              >
                <v-icon large dark>mdi-barcode</v-icon>
              </v-btn>
              </template>
            <span>Abrir o boleto do membro.</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn fab dark color="teal"
                v-on="on"
                v-if="user && user.transaction && user.transaction.id && user.status !== 'paid'"
                @click.prevent="updateuser(user.id, user.transaction.id)">
                <v-icon large>find_replace</v-icon>
              </v-btn>
            </template>
            <span>Atualizar a transação conforme Pagar.me.</span>
          </v-tooltip>
        </div> -->
        <v-divider />
        <div>
          <h4>Faturas</h4>
          <div class="pr-2">
            <v-text-field
              v-model="search"
              append-icon="search"
              label="Busca"
              single-line
              hide-details
            ></v-text-field>
            <v-data-table :headers="headers" :items="billing" :search="search">
              <template v-slot:no-data>
                <v-alert :value="true" color="error" icon="warning">
                  Nenhuma fatura encontrada :(
                </v-alert>
              </template>
              <template v-slot:items="props">
                <td>{{ props.item.competence | formatCompetence }}</td>
                <td class="text-xs-right">
                  <v-icon
                    :color="
                      props.item.status === 'paid' ||
                      props.item.status === 'paga' ||
                      props.item.status === 'succeeded'
                        ? 'green'
                        : 'gray'
                    "
                  >
                    {{ props.item.status | statusFatura }}
                  </v-icon>
                </td>
              </template>
              <template v-slot:pageText="props">
                Faturas {{ props.pageStart }} - {{ props.pageStop }} de
                {{ props.itemsLength }}
              </template>
              <template v-slot:no-results>
                <v-alert :value="true" color="error" icon="warning">
                  Sua busca por "{{ search }}" não retornou resultados.
                </v-alert>
              </template>
            </v-data-table>
          </div>
        </div>
      </v-flex>
    </v-navigation-drawer>
    <v-snackbar :color="color" top v-model="snackbar" dark>
      <v-icon color="white" class="mr-3"> mdi-bell-plus </v-icon>
      <div>{{ snackMessage }}</div>
      <v-icon size="16" @click="snackbar = false"> mdi-close-circle </v-icon>
    </v-snackbar>
  </v-layout>
</template>

<script>
// Utilities
// import { getuser } from '../../services/user'
import { eventBus } from "../../main";
import firestore from "../../firebase/firestore";
import moment from "moment";

export default {
  name: "DetalhesFatura",
  data: () => ({
    search: "",
    logo: "../../img/newJuntos_logo_color.png",
    partner: "enercred",
    showDrawer: false,
    user_id: "",
    billing: [],
    uc_id: "",
    uc: {},
    error: "",
    right: false,
    responsive: false,
    loading: false,
    dialog: false,
    color: "",
    snackMessage: "",
    snackbar: false,
    headers: [
      {
        text: "Competencia",
        align: "left",
        sortable: true,
        value: "competence",
      },
      { text: "status", value: "status", sortable: false },
    ],
    // billing: [
    //   {
    //     competence: '2020-04',
    //     status: 'pending'
    //   },
    //   {
    //     competence: '2020-03',
    //     status: 'paid'
    //   },
    //   {
    //     competence: '2020-02',
    //     status: 'paid'
    //   }
    // ]
  }),
  created() {
    var vm = this;
    vm.loading = true;
    eventBus.$on("rightcustomerdetail", function (value) {
      vm.right = value;
      // this.loading = false
    });
    eventBus.$on("user_detail", function (value) {
      // console.log('uc: ', value)
      //   this.uc = value
      if (value.user_id) {
        firestore
          .collection("users")
          .doc(value.user_id)
          .get()
          .then(async (user) => {
            // console.log('u: ', user)
            const uc = {
              ...value,
              user: {
                id: user.id,
                ...user.data(),
              },
            };
            vm.uc = uc;
            const billing = await firestore
              .collection("billing")
              .where("customer_id", "==", uc.user.id)
              .orderBy("competence", "desc")
              .get()
              .then((bill) =>
                bill.docs.map((doc) => {
                  return { id: doc.id, ...doc.data() };
                }),
              )
              .catch((err) => {
                vm.snack("Erro ao pegar unidades faturas do usuário", "red");
                vm.error = "Erro ao pegar unidades faturas do usuário";
                console.error(err);
              });
            vm.billing = billing;
            // console.log('billing: ', billing)
            vm.loading = false;
            // console.log('x: ', vm.uc)
          })
          .catch((error) => {
            vm.snack("Erro ao pegar usuário da unidade consumidora", "red");
            vm.error = "Erro ao pegar usuário da unidade consumidora";
            console.error(error);
          });
      } else {
        vm.snack(
          "Não possui id do usuário. Entre em contato com o suporte!",
          "red",
        );
        vm.error = "Não possui id do usuário. Entre em contato com o suporte!";
        vm.loading = false;
      }
    });
  },
  methods: {
    snack(message, color) {
      // this.top = false
      // this.bottom = false
      // this.left = false
      // this.right = false

      // for (const loc of args) {
      // 		this[loc] = true
      // }

      this.color = color;
      this.snackMessage = message;
      this.snackbar = true;
    },
  },
  filters: {
    formatDateTime(value) {
      if (!value || value === "") return "";
      return moment(value.toDate()).format("DD/MM/YYYY HH:mm");
    },
    formatCurrency(value) {
      if (!value || value === "") return "";
      const new_value = Number(value);
      return new_value.toFixed(2).replace(".", ",");
    },
    formatKWCurrency(value) {
      if (!value || value === "") return "";
      const new_value = Number(value);
      return new_value.toFixed(8).replace(".", ",");
    },
    formatCPF(value) {
      if (!value || value === "") return "";
      return value.replace(
        /(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/g,
        // eslint-disable-next-line no-useless-escape
        "\$1.\$2.\$3\/\$4\-\$5",
      );
    },
    statusFatura: function (value) {
      if (!value) return "";

      if (value === "paga" || value === "succeeded" || value === "paid") {
        return "done_outline";
      } else if (
        value === "aberta" ||
        value === "pending" ||
        value === "waiting_payment" ||
        value === "opened"
      ) {
        return "schedule";
      } else if (value === "overdue") {
        return "schedule";
      } else if (value === "free") {
        return "free_breakfast";
      } else {
        return "error";
      }
    },
    formatCompetence: function (value) {
      if (!value || value === "") return "";
      return value.split("-")[1] + "/" + value.split("-")[0];
    },
  },
  computed: {
    status: function () {
      if (this.uc.status === "") return "xxx";
      else if (this.uc.status === "activated") return "ATIVO";
      else if (this.uc.status === "canceling") return "CANCELANDO";
      else if (
        this.uc.status === "inactivated" ||
        this.uc.status === "canceled"
      )
        return "INATIVO";
      else return "?";
    },
  },
};
</script>
<style scoped lang="scss">
.detail-status {
  height: 25px;
  color: #fff;
  // font-size: 15px;
  border-radius: 3px;
  font-weight: 600;
  text-align: center;
  padding: 0px 10px;
  &--activated {
    background-color: #3cb880;
  }
  &--inactivated {
    background-color: red;
    color: FFF;
  }
  &--canceled {
    background-color: red;
    color: FFF;
  }
  &--canceling {
    background-color: orange;
    color: FFF;
  }
  &--pending {
    background-color: #888;
  }
  &--waiting_payment {
    background-color: #888;
  }
  &--overdue {
    background-color: red;
  }
  &--opened {
    background-color: #888;
  }
  &--reprocessing {
    background-color: #333;
    color: #fff;
  }
}

.sub-title {
  color: #777;
  font-size: 0.8rem;
}

.title {
  font-size: 1rem !important;
  color: #333;
  font-weight: 400;
}

.v-list__tile__sub-title {
  color: #777;
  font-size: 0.8rem;
}

.v-btn {
  // padding-top: 50px;
  border-radius: 50%;
  height: 48px;
  // max-width: 28px;
  width: 48px;
}

.error {
  font-size: 0.8rem;
  color: red;
}
</style>
